import { AllowedValues } from 'components/MCTextEditor/types'

export const parseValue = (input?: AllowedValues): string => {
  if (typeof input === 'string') {
    return input
  }
  if (input === null) {
    return ''
  }
  return String(input)
}
